export const replyWithAttachmentLastModifiedText = "plb";
export const accessedOnText = "qlb";
export const replyWithMenuHeaderText = "rlb";
export const suggestedFilesText = "slb";
export const suggestedAttachmentsReceivedFromText = "tlb";
export const suggestedAttachmentsReceivedFromAgoText = "ulb";
export const suggestedAttachmentsReceivedAgoText = "vlb";
export const suggestedAttachmentsOnText = "wlb";
export const suggestedAttachmentsOnOnedriveText = "xlb";
export const suggestedAttachmentsModifiedByText = "ylb";
export const suggestedAttachmentsCreatedByOwnerText = "zlb";
export const suggestedAttachmentsSentText = "Alb";
export default {replyWithAttachmentLastModifiedText,accessedOnText,replyWithMenuHeaderText,suggestedFilesText,suggestedAttachmentsReceivedFromText,suggestedAttachmentsReceivedFromAgoText,suggestedAttachmentsReceivedAgoText,suggestedAttachmentsOnText,suggestedAttachmentsOnOnedriveText,suggestedAttachmentsModifiedByText,suggestedAttachmentsCreatedByOwnerText,suggestedAttachmentsSentText};